import React from "react";
import { Modal, Typography, Row, Col, Card, Divider, Tag } from "antd";
import {
  DollarOutlined,
  GiftOutlined,
  InfoCircleOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const EarningDetailsDialog = ({ open, onClose, product }) => {
  if (!product) return null;

  const formatAmount = (amount, type) =>
    type === "FLAT" ? `₹${amount}` : `${amount}%`;

  const amountColor = "#52c41a";
  const highlightColor = "#1890ff";

  const cardStyle = {
    textAlign: "center",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    height: "180px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",
    border: "1px solid #f0f0f0",
    transition: "all 0.3s ease",
  };

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <Title level={4} style={{ margin: 0, color: "#1d1d1d" }}>
            Earnings Breakdown
          </Title>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      bodyStyle={{ padding: "24px" }}
      className="earning-details-modal"
    >
      {/* Product Info Header */}
      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <Text strong style={{ fontSize: "16px", color: "#595959" }}>
          {product?.name}
        </Text>
      </div>

      {/* Total Earnings Banner */}
      <Card
        style={{
          borderRadius: "10px",
          background: "linear-gradient(135deg, #f6ffed 0%, #e6f7ff 100%)",
          border: "1px solid #d9f7be",
          marginBottom: "24px",
          textAlign: "center",
          padding: "12px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "32px",
            opacity: 0.1,
            color: highlightColor,
          }}
        >
          <DollarOutlined />
        </div>
        <Text type="secondary" style={{ fontSize: "15px", display: "block" }}>
          Your Potential Earnings
        </Text>
        <Title level={2} style={{ color: amountColor, margin: "8px 0 0" }}>
          {formatAmount(
            parseFloat(product.amount || 0) +
              parseFloat(product.bonus_amount || 0),
            product.payout_type
          )}
        </Title>
        {product.payout_type === "PERCENTAGE" && (
          <Tag color="blue" style={{ marginTop: "8px" }}>
            <ArrowUpOutlined /> Percentage-based
          </Tag>
        )}
      </Card>

      <Divider
        orientation="left"
        plain
        style={{ fontSize: "14px", color: "#8c8c8c" }}
      >
        <InfoCircleOutlined style={{ marginRight: "8px" }} />
        Earnings Components
      </Divider>

      {/* Base & Bonus Cards */}
      <Row gutter={[24, 24]} justify="center">
        <Col
          xs={24}
          sm={
            product.bonus_amount == null || product.bonus_amount === 0 ? 16 : 12
          }
        >
          <Card
            hoverable
            style={{
              ...cardStyle,
              borderTop: `4px solid ${highlightColor}`,
            }}
          >
            <Title level={3} style={{ color: amountColor, margin: 0 }}>
              {formatAmount(product.amount, product.payout_type)}
            </Title>

            <Text
              type="secondary"
              style={{
                fontSize: "13px",
                marginTop: "8px",
              }}
            >
              {product.base_earning_note}
            </Text>
          </Card>
        </Col>

        {product.bonus_amount == null || product.bonus_amount === 0 ? null : (
          <Col xs={24} sm={12}>
            <Card
              hoverable
              style={{
                ...cardStyle,
                borderTop: "4px solid #ff7a45",
              }}
            >
              <Title level={3} style={{ color: amountColor, margin: 0 }}>
                {formatAmount(product.bonus_amount, product.payout_type)}
              </Title>
              <Text
                type="secondary"
                style={{
                  fontSize: "13px",
                  marginTop: "8px",
                }}
              >
                {product.bonus_earning_note}
              </Text>
            </Card>
          </Col>
        )}
      </Row>

      {/* Additional Info */}
      <div
        style={{
          marginTop: "24px",
          padding: "12px 16px",
          background: "#fafafa",
          borderRadius: "8px",
          borderLeft: `3px solid ${highlightColor}`,
        }}
      >
        <Text type="secondary" style={{ fontSize: "13px" }}>
          <InfoCircleOutlined style={{ marginRight: "8px" }} />
          Earnings are calculated based on the final transaction amount and may
          vary.
        </Text>
      </div>
    </Modal>
  );
};

export default EarningDetailsDialog;
